angular.module('ikeweb.unit').filter('area', ['measurementFormatterService',
    function(measurementFormatterService) {

        function area(value) {
            return measurementFormatterService.formatArea((value || 0));
        }
        area.$stateful = true;

        return area;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/unit/filters/area.filter.js
// module id = 442
// module chunks = 0